// Pagine che parlano col dispositivo: esistono solo nell'app desktop.
export default function ({ app, redirect }) {
  if (process.env.platform !== 'electron') redirect(app.localePath('index'))
}
